import React from "react";
import Filter from "./Filter";
import Sort from "./Sort";

function Sidebar() {
  return (
    <aside>
      <div className="sidebar-items">
        <Sort />
        <Filter />
      </div>
    </aside>
  );
}

export default Sidebar;
